export default "__VITE_ASSET__DBtv3ftF__"